export enum ActionConditionType {
  None = 0,
  Guid = 1,
  Name = 2,
}
